/**
 * author ZWH.
 * forked from https://github.com/zwhGithub/vue-calendar
 */
import Calendar from './calendar.vue'
export default Calendar
